import React, { useEffect, useState } from "react";
import { apiGet } from "../../../API/Api_Url";

function AllMyReviews() {
  const [reviews, setReviews] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const GetAllReviews = async () => {
    try {
      setIsLoading(true);
      const response = await apiGet(`api/freelance-engineer/GetAllMyReviews`);
      setReviews(response?.data || []);
    } catch (error) {
      console.error("Error fetching data:", error);
      setReviews([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    GetAllReviews();
  }, []);

  return (
    <div className="p-4">
      <h2 className="text-xl font-bold mb-4">My Reviews</h2>

      {isLoading ? (
        <p className="text-gray-500">Loading reviews...</p>
      ) : reviews?.length === 0 ? (
        <p className="text-gray-500">No reviews found</p>
      ) : (
        <div className="space-y-4">
          {reviews?.map((review) => (
            <div
              key={review?._id}
              className="border rounded-lg p-4 shadow-sm bg-white"
            >
              <div className="mb-2">
                <h3 className="font-semibold">{review?.User?.name}</h3>
                <p className="text-sm text-gray-500">
                  {review?.User?.email} | {review?.User?.phone}
                </p>
              </div>
              <div className="mb-2">
                <p className="font-medium">⭐ {review?.Rating}/5</p>
                <p className="text-gray-700">{review?.Review}</p>
              </div>
              {review?.Contractor && (
                <div className="mt-3 p-3 border-t border-gray-200 bg-gray-50 rounded-lg">
                  <h4 className="font-semibold text-gray-700">Contractor Info</h4>
                  <p className="text-sm">
                    <span className="font-medium">Name:</span>{" "}
                    {review?.Contractor?.name}
                  </p>
                  <p className="text-sm">
                    <span className="font-medium">Company:</span>{" "}
                    {review?.Contractor?.companyName}
                  </p>
                  <p className="text-sm">
                    <span className="font-medium">Email:</span>{" "}
                    {review?.Contractor?.email}
                  </p>
                  <p className="text-sm">
                    <span className="font-medium">Phone:</span>{" "}
                    {review?.Contractor?.phone}
                  </p>
                </div>
              )}
              <p className="text-xs text-gray-400 mt-2">
                {new Date(review?.createdAt)?.toLocaleString()}
              </p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default AllMyReviews;
